// src/context/UserContext.js
import { createContext, useEffect, useState } from "react";
import PropTypes from "prop-types"; // Import PropTypes

export const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    console.log("Context id", userId);
  }, [userId]);

  return <UserContext.Provider value={{ userId, setUserId }}>{children}</UserContext.Provider>;
};

UserProvider.propTypes = {
  children: PropTypes.node.isRequired, // Define the 'children' prop
};
